import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { initialAndSearchStateSetter } from '../../Utility/InitialAndSearchStateSetter/InitialAndSearchStateSetter';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import { mapStateToPropsForAllData } from '../../Utility/MapStateToPropsForAllData/MapStateToPropsForAllData';


function Accounts({ allDataOfContact, searchedDataOfContact }) {

  const [isLoading, setIsLoading] = useState(true);
  const [accountsData, setAccountsData] = useState({});
  const navigate = useNavigate();
  const { searchedKeyword } = useParams();

  useEffect(() => {

    initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setAccountsData, allDataOfContact);

  }, [allDataOfContact, searchedDataOfContact, isLoading, searchedKeyword]);


  return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
      <Typography
           component="h1"
           variant="h6"
           color="inherit"
           noWrap
           sx={{ flexGrow: 1, textAlign: 'center', fontWeight: 'bold', marginBottom: "20px", textDecoration: "underline" }}
         >
           My Account
         </Typography>
         { isLoading ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
   <CircularProgress />
 </Box> : ((accountsData?.data && accountsData?.data?.Accounts && accountsData?.data?.Accounts?.totalSize) != 0 ?  <Grid container>{ accountsData?.data && accountsData?.data?.Accounts?.records?.map((accountData) => {

  let addressDetail = `${accountData?.ShippingAddress?.street == null ? "" : accountData?.ShippingAddress?.street} ${accountData?.ShippingAddress?.city == null ? "" : accountData?.ShippingAddress?.city+", "} ${accountData?.ShippingAddress?.state == null ? "" : accountData?.ShippingAddress?.state+", "} ${accountData?.ShippingAddress?.country == null ? "" : accountData?.ShippingAddress?.country+", "} ${accountData?.ShippingAddress?.postalCode == null ? "" : accountData?.ShippingAddress?.postalCode+"."}`;

   return <Grid container><Grid container rowSpacing={1} justifyContent="space-around" style={{ textAlign: "left" }} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
   <Grid item xs={5}>
   <h5 style={{ margin: "0px" }} >Account Name</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Name}</p>
   <h5 style={{ margin: "0px" }} >Phone</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Phone}</p>
   <h5 style={{ margin: "0px" }} >Type</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Type}</p>
   <h5 style={{ margin: "0px" }} >Industry</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Industry}</p>
   </Grid>
   <Grid item xs={5}>
   <h5 style={{ margin: "0px" }} >Annual Revenue</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.AnnualRevenue}</p>
   <h5 style={{ margin: "0px" }} >Active</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Active__c}</p>
   <h5 style={{ margin: "0px" }} >Acc Owner</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{accountData.Owner.Name}</p>
   <h5 style={{ margin: "0px" }} >Address</h5>
   <p style={{ margin: "0px", marginBottom: "16px" }} >{addressDetail}</p>
   </Grid>
   </Grid> 
   </Grid>
 }) }
       <Grid container justifyContent="center">
            <Link to={`/AccountDetail/${generateRandomString()+"00JZ3"+accountsData?.data?.Accounts?.records[0].Id+generateRandomString()}`} style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="button"
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Edit
            </Button>
            </Link>
            </Grid>
      </Grid>
   : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>) }
     
   </Grid> 
   </Container>
 
  )
}

export default connect(mapStateToPropsForAllData)(Accounts);